// extracted by mini-css-extract-plugin
export default {"container":"wwuUFWyuwSAqkYn0jWC8+w==","organisationInfo":"t9E1M2TouzC18CxS4ukDjg==","shortDescription":"pU2Jy0kcE2mISfjtrR-Qow=="};